import { AxiosRequest } from './AxiosRequest';
import qs from 'qs';
import { axiosPostContentType, EParamsSendType, RequestConfig } from './IAxiosRequest';
import { Method } from 'axios';

export class Http extends AxiosRequest {
  /**
   * get 方法
   * @param url 接口地址
   * @param query get 对应的query
   * @param opts request-config [{@link RequestConfig}]
   */
  static async get<T>(url: string, query: object = {}, opts = {} as RequestConfig) {
    delete opts.paramsSendType;
    const res = await Http.common<T>({
      method: 'get',
      url,
      params: query,
      ...opts,
    });

    return res;
  }

  /**
   * post 方法
   * @param url 接口地址
   * @param body post 对应的参数
   * @param opts request-config [{@link RequestConfig}]
   */
  static async post<T>(
    url: string,
    body: object = {},
    opts = {} as RequestConfig,
  ) {
    opts.paramsSendType = opts.paramsSendType || EParamsSendType.RequestPayload;
    return Http.commonHandler<T>('post', url, body, opts);
  }

  /**
   * put 方法
   * @param url 接口地址
   * @param body put 对应的参数
   * @param opts request-config [{@link RequestConfig}]
   */
  static async put<T>(
    url: string,
    body: object = {},
    opts = {} as RequestConfig,
  ) {
    return Http.commonHandler<T>('put', url, body, opts);
  }

  /**
   * delete 方法
   * @param url 接口地址
   * @param body delete 对应的参数
   * @param opts request-config [{@link RequestConfig}]
   */
  static async delete<T>(
    url: string,
    body: object = {},
    opts = {} as RequestConfig,
  ) {
    return Http.commonHandler<T>('delete', url, body, opts);
  }

  /**
   * post/put/delete 方法
   * @param url 接口地址
   * @param body post/put/delete 对应的参数
   * @param opts request-config [{@link RequestConfig}]
   */
  static async commonHandler<T>(
    method: Method,
    url: string,
    body: object = {},
    opts = {} as RequestConfig,
  ) {
    const { paramsSendType, headers: customHeaders, needLogin, ...restOptions } = opts;
    const isFormDatadMode = paramsSendType === EParamsSendType.FormData;

    const headers = customHeaders || {};
    const contentType = headers['Content-Type'] || axiosPostContentType[paramsSendType];
    let params: RequestConfig = {
      method,
      url,
      headers: {
        ...headers,
        'Content-Type': contentType,
      },
      ...restOptions,
      data: isFormDatadMode ? qs.stringify(body) : body,
    };

    const res = await Http.common<T>(params);

    return res;
  }
}
